import { config } from "../../../services/config";
import { pivateOptions } from "../../../services/api";

export const getAllCompras = async (q = "") => {
  const url = `${config.URL_API}/usuario/compras?${q}`;
  const response = await fetch(url, pivateOptions('GET'));
  const data = response.json();
  return data;
}

export const getCompra = async (id) => {
  const url = `${config.URL_API}/usuario/compra/${id}`;
  const response = await fetch(url, pivateOptions('GET'));

  if (!response.ok) {
    const error = new Error('Error en la petición');
    error.response = {
      status: response.status,
      statusText: response.statusText
    };
    throw error;
  }

  const data = await response.json();
  return data;
};

// mesas enteras de la compra: qué tickets van dentro de la mesa y su detalle
export const getMesasCompra = async (id) => {
  const response = await fetch(`${config.URL_API}/usuario/compra/${id}/mesas`, pivateOptions('GET'));
  if (!response.ok) return null;
  const data = await response.json();
  return data?.status === "success" ? data.data : null;
};

export const downloadItemPDF = async (itemId, type = 'ticket') => {
  const endpoint = type === 'voucher' ? 'vouchers' : 'tickets';
  const url = `${config.URL_API}/api/${endpoint}/download/${itemId}`;
  const response = await fetch(url, {
    ...pivateOptions('GET'),
    responseType: 'blob',
  });

  if (!response.ok) {
    throw new Error(`Error al descargar el ${type === 'voucher' ? 'voucher' : 'ticket'}`);
  }

  return response.blob();
};

export const downloadTicketPDF = async (ticketId) => {
  return downloadItemPDF(ticketId, 'ticket');
};

export const downloadVoucherPDF = async (voucherId) => {
  return downloadItemPDF(voucherId, 'voucher');
};